// MODULES =====================================================================
import Rails from 'rails-ujs'
import "../scripts/pages/vue"

import "stylesheets/application.sass"
import "stylesheets/tailwind.sass"

import Animation from "@utils/animation-scroll"
import Calendar from "@utils/calendar"
import ConstantHeight from "@utils/constant-height"
import Menu from "@utils/menu"
import MenuActive from "@utils/menu-active"
import Dropdown from "@utils/dropdown"
import Readmore from "@utils/readmore"
import GoogleMap from "@utils/google-map"

// Fonts ===============================================================
import "typeface-lato"

// Stimulus
import "@controllers"

// CONFIGURATION ===============================================================
Rails.start()

document.addEventListener("DOMContentLoaded", () => {
  new Animation()
  new Calendar()
  new ConstantHeight()
  new Menu()
  new Dropdown()
  new MenuActive()
  new Readmore()
  new GoogleMap()
})
